import {createRouter, createWebHistory} from 'vue-router'
import Catalogue from "@/components/Catalogue";
import Activity from "@/components/Activity";
import Form from "@/components/Form";
import App from "@/App";

const routes = [
    {
        path: '/',
        name: 'App',
        component: App,
        redirect: to => {
            return {path: '/catalogue', query: {catalogue: to.query.catalogue, style: to.query.style}}
        }
    },
    {
        path: '/catalogue',
        name: 'Catalogue',
        component: Catalogue,
        props(route) {
            return route.query || {}
        }
    },
    {
        path: '/activity',
        name: 'Activity',
        component: Activity,
        props(route) {
            return route.query || {}
        }
    },
    {
        path: '/form/:catalogueId/:activityId/:id',
        name: 'Form',
        component: Form,
        props: true,
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
